<template>
  <asc-previous-next-buttons
    :on-previous-report="handlePreviousClick"
    :previous-disabled="previousDisabled"
    :on-next-report="handleNextClick"
    :next-disabled="nextDisabled"
    data-automation-id="wrapper_report_nav"
  ></asc-previous-next-buttons>
</template>

<script>
import { AscPreviousNextButtonsMixin } from '@/components/mixins'
import AscPreviousNextButtons from '@/components/molecules/AscPreviousNextButtons'

export default {
  name: 'AscReportNavWrapper',

  components: {
    AscPreviousNextButtons,
  },

  mixins: [AscPreviousNextButtonsMixin],

  methods: {
    handlePreviousClick() {
      if (this.onPreviousReport) {
        this.onPreviousReport()
      }
    },
    handleNextClick() {
      if (this.onNextReport) {
        this.onNextReport()
      }
    },
  },
}
</script>
